/**
 * Connection metadata required to resolve receiver connect time.
 */
export type CallConnectionWithConnectedAt = {
  connectedAt?: number | null;
};

/**
 * Returns the receiver's connect timestamp for a call with completed connections.
 * Completed connections are ordered by `connectedAt`; when two or more exist, the
 * second connection's time is used (both parties on the line).
 * @param connections Call connection records.
 * @returns Epoch milliseconds for the receiver connect, if available.
 */
export function getCallReceiverConnectedAt(
  connections: ReadonlyArray<CallConnectionWithConnectedAt> | undefined
): number | undefined {
  const completedConnections = (connections ?? [])
    .filter(
      (
        connection
      ): connection is CallConnectionWithConnectedAt & { connectedAt: number } =>
        Boolean(connection?.connectedAt)
    )
    .sort((a, b) => a.connectedAt - b.connectedAt);

  const receiverConnection =
    completedConnections.length > 1
      ? completedConnections[1]
      : completedConnections[0];

  return receiverConnection?.connectedAt;
}
